﻿import { IMicrositeRecipientImageAttributes } from ".";

export interface IMicrositeRecipientImage {
    id: string,
    caption: string,
    fileName: string,
    thumbnail: string,
    displayOrder: number,
    attributes: IMicrositeRecipientImageAttributes
}
